module.exports = __webpack_public_path__ + "img/7.2-gallery.802bec32.jpg";